import { render, staticRenderFns } from "./UpdateSalesQuote.vue?vue&type=template&id=10c19260&"
import script from "./UpdateSalesQuote.vue?vue&type=script&lang=js&"
export * from "./UpdateSalesQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports